<head>
    <!-- Google Tag Manager -->

    <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

    <!-- End Google Tag Manager -->
</head>
<!-- Google Tag Manager (noscript) -->

<noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0"
        style="display:none;visibility:hidden"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->
<div class="template" style="overflow:hidden">
    <div class="px-4 py-5 my-5 text-center demo-wrap" style="padding-bottom: 10px !important;
    padding-top: 10px !important; margin-top: 0rem !important; margin-bottom: 0rem !important;">
        <img class="demo-bg" src="../../assets/img/Checker.png" alt="">
        <div class="demo-content">
            <div class="col-lg-6 mx-auto">
                <p class="lead mb-4"
                    style="color: black; font-size: 31px; font-weight: 400; margin-bottom: 2rem !important">Simplified
                    Online Trading</p>
                <div style="width:100%; text-align: center;">
                    <a [routerLink]="['/join-us']" class="btn joinUsBtn" rel="noopener noreferrer" id="homeJoinUs1"
                        (click)="capturePos()">Join us on eToro</a><br /><br />
                    <div style="font-size:small;">
                        Copy Trading does not amount to investment advice. Your investments value may go up or down.
                        Your capital is at risk.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br /><br />
    <div class="row">
        <div class="col wow fadeInUp" data-wow-delay=".5s"
            style="text-align: center;display: flex;
        flex-wrap: wrap;
        align-content: center; background-color: white; border-style: solid; border-color: #E3E3E3; border-width: 1.5rem; margin-left: 5rem; margin-right: 2.5rem"
            *ngIf="!mobile">
            <section class="section section--primary" style="background-color: white; padding-top: 0rem;">
                <div class="shell shell--size-4">
                    <div class="section__background"></div><!-- /.section__background -->

                    <div class="section__head">

                        <h2>Why Backseat Trader?</h2>
                    </div><!-- /.section__head -->

                    <ul class="list-services" id="about" *ngIf="mobile">
                        <li>
                            <img src="assets/img/svg/ico-service-1.svg" alt="Service 1" loading="lazy">

                            <p class="servicesFontSize">Performance driven algorithm</p>
                        </li>

                        <li>
                            <img src="assets/img/svg/ico-service-2.svg" alt="Service 2" loading="lazy">

                            <p class="servicesFontSize">Simple to use in one click</p>
                        </li>

                        <li>
                            <img src="assets/img/svg/ico-service-3.svg" alt="Service 3" loading="lazy">

                            <p class="servicesFontSize">Well curated portfolio</p>
                        </li>
                    </ul><!-- /.list-services -->

                    <ul class="list-services" *ngIf="!mobile">
                        <li>
                            <img src="assets/img/svg/ico-service-1.svg" alt="Service 1" loading="lazy">

                            <p class="servicesFontSize">Performance driven algorithm</p>
                        </li>

                        <li>
                            <img src="assets/img/svg/ico-service-2.svg" alt="Service 2" loading="lazy">

                            <p class="servicesFontSize">Simple to use in one click</p>
                        </li>

                        <li>
                            <img src="assets/img/svg/ico-service-3.svg" alt="Service 3" loading="lazy">

                            <p class="servicesFontSize">Well curated portfolio</p>
                        </li>
                    </ul><!-- /.list-services -->
                    <div class="section__foot" id="about" *ngIf="!mobile">
                        <h6>Robust logic</h6>

                        <h5 class="colorBlack">Our algorithm is based on a Risk / Return Model which is moderate
                            targeting
                            a 15-25% gain for
                            you annually.</h5>

                    </div><!-- /.section__foot -->
                </div><!-- /.shell -->
            </section><!-- /.section -->
        </div>
        <div class="col wow fadeInUp" data-wow-delay=".5s"
            style="text-align: center;display: flex;
        flex-wrap: wrap;
        align-content: center; background-color: white; border-style: solid; border-color: #E3E3E3; border-width: 1.5rem;" *ngIf="mobile">
            <section class="section section--primary" style="background-color: white; padding-top: 0rem;">
                <div class="shell shell--size-4">
                    <div class="section__background"></div><!-- /.section__background -->

                    <div class="section__head">

                        <h2>Why Backseat Trader?</h2>
                    </div><!-- /.section__head -->

                    <ul class="list-services" id="about" *ngIf="mobile">
                        <li>
                            <img src="assets/img/svg/ico-service-1.svg" alt="Service 1" loading="lazy">

                            <p class="servicesFontSize">Performance driven algorithm</p>
                        </li>

                        <li>
                            <img src="assets/img/svg/ico-service-2.svg" alt="Service 2" loading="lazy">

                            <p class="servicesFontSize">Simple to use in one click</p>
                        </li>

                        <li>
                            <img src="assets/img/svg/ico-service-3.svg" alt="Service 3" loading="lazy">

                            <p class="servicesFontSize">Well curated portfolio</p>
                        </li>
                    </ul><!-- /.list-services -->

                    <ul class="list-services" *ngIf="!mobile">
                        <li>
                            <img src="assets/img/svg/ico-service-1.svg" alt="Service 1" loading="lazy">

                            <p class="servicesFontSize">Performance driven algorithm</p>
                        </li>

                        <li>
                            <img src="assets/img/svg/ico-service-2.svg" alt="Service 2" loading="lazy">

                            <p class="servicesFontSize">Simple to use in one click</p>
                        </li>

                        <li>
                            <img src="assets/img/svg/ico-service-3.svg" alt="Service 3" loading="lazy">

                            <p class="servicesFontSize">Well curated portfolio</p>
                        </li>
                    </ul><!-- /.list-services -->
                    <div class="section__foot" id="about" *ngIf="!mobile">
                        <h6>Robust logic</h6>

                        <h5 class="colorBlack">Our algorithm is based on a Risk / Return Model which is moderate
                            targeting
                            a 15-25% gain for
                            you annually.</h5>

                    </div><!-- /.section__foot -->
                </div><!-- /.shell -->
            </section><!-- /.section -->
        </div>
        <div *ngIf="mobile"><br /><br /></div>
        <div class="col wow fadeInUp" data-wow-delay="1s"
            style="text-align: center; border-style: solid; border-color: #E3E3E3; border-width: 1.5rem; margin-left: 2.5rem; margin-right: 5rem"
            *ngIf="!mobile">
            <section class="section-image">
                <div class="shell">
                    <div class="section__foot" id="about" *ngIf="!mobile" style="margin-bottom: 7rem">

                        <h5 class="colorBlack" style="font-size: 2.4rem;
                        color: #fff;
                        letter-spacing: -0.01em;
                        margin-bottom: 2.5rem;
                        font-weight: 600;">Our algorithm is based on a Risk / Return Model which is moderate targeting
                            a 15-25% gain for
                            you annually.</h5>

                    </div><!-- /.section__foot -->
                    <div class="section__image"></div>
                    <!-- /.section__image -->

                    <div class="section__content">
                        <img src="assets/img/svg/ico-award.svg" alt="Award" loading="lazy" />


                        <h3 class="howItWorks">How it works
                            <a (click)="etoroInf(6)" id="HowItWorks"><i
                                    class="fa-solid fa-circle-info fa-lg howItWorksi" placement="top"
                                    ngbTooltip="Read More" tooltipClass="toolTips" id="howItWorksIcon"></i></a>

                        </h3>

                        <ul style="margin-bottom: 0rem">
                            <button (click)="etoroInf(2)" id="SmartStock" type="button" class="landingBtn btn-primary">
                                <li>
                                    <img src="assets/img/svg/ico-list-1.svg" alt="Item 1" loading="lazy" />

                                    <h5>Smart Stock Curation</h5>

                                    <p style="color: black">It analyses all stock trading on the NASDAQ-100 Index, from
                                        there it selects the Top 20
                                        to
                                        trade on a monthly rotation.</p>
                                </li>
                            </button>

                            <br /><br />

                            <button (click)="etoroInf(3)" id="SmartStock" type="button" class="landingBtn btn-primary">
                                <li>
                                    <img src="assets/img/svg/ico-list-2.svg" alt="Item 2" loading="lazy">

                                    <h5>Advanced Analytics & Intelligence</h5>

                                    <p style="color: black">Each month the algorithm updates the Top 20 for the coming
                                        month. Selecting the Top 20
                                        provides diversification within the portfolio.</p>
                                </li>
                            </button>

                            <br /><br />

                            <button (click)="etoroInf(4)" id="SmartStock" type="button" class="landingBtn btn-primary">
                                <li>
                                    <img src="assets/img/svg/ico-list-3.svg" alt="Item 3" loading="lazy">

                                    <h5>Diversified Approach</h5>

                                    <p style="color: black">This diversification reduces risk exposure whilst targeting
                                        a net-profit of 15 – 25%.</p>
                                </li>
                            </button>
                        </ul>


                        <div *ngIf="!mobile">
                            <a (click)="etoroInf(1)" id="Etoro"><img src="assets/img/svg/section-icon-1.svg"
                                    loading="lazy" alt="Click here for more eToro information"
                                    class="section__icon etoroBtnHowDesk"></a>
                        </div>
                        <div *ngIf="mobile" class="etoroBtnPosMob">
                            <a (click)="etoroInf(1)" id="Etoro"><img src="assets/img/svg/section-icon-1.svg"
                                    loading="lazy" alt="Click here for more eToro information"
                                    class="etoroBtnHowDesk"></a>
                        </div>

                    </div><!-- /.section__content -->
                </div><!-- /.shell -->
            </section>
        </div>
        <div class="col wow fadeInUp" data-wow-delay="1s"
            style="text-align: center; border-style: solid; border-color: #E3E3E3; border-width: 1.5rem;"
            *ngIf="mobile">
            <section class="section-image">
                <div class="shell">
                    <div class="section__foot" id="about" *ngIf="!mobile" style="margin-bottom: 7rem">

                        <h5 class="colorBlack" style="font-size: 2.4rem;
                    color: #fff;
                    letter-spacing: -0.01em;
                    margin-bottom: 2.5rem;
                    font-weight: 600;">Our algorithm is based on a Risk / Return Model which is moderate targeting
                            a 15-25% gain for
                            you annually.</h5>

                    </div><!-- /.section__foot -->
                    <div class="section__image"></div>
                    <!-- /.section__image -->

                    <div class="section__content">
                        <br /><br />
                        <img src="assets/img/svg/ico-award.svg" alt="Award" loading="lazy" />


                        <h3 class="howItWorks">How it works
                            <a (click)="etoroInf(6)" id="HowItWorks"><i
                                    class="fa-solid fa-circle-info fa-lg howItWorksi" placement="top"
                                    ngbTooltip="Read More" tooltipClass="toolTips" id="howItWorksIcon"></i></a>

                        </h3>

                        <ul style="margin-bottom: 0rem">
                            <button (click)="etoroInf(2)" id="SmartStock" type="button" class="landingBtn btn-primary">
                                <li class="padTopMobileButton">
                                
                                    <img src="assets/img/svg/ico-list-1.svg" alt="Item 1" loading="lazy" />

                                    <h5 style="line-height: 96%">Smart Stock Curation</h5>

                                    <p style="color: black">It analyses all stock trading on the NASDAQ-100 Index, from
                                        there it selects the Top 20
                                        to
                                        trade on a monthly rotation.</p>
                               
                                </li>
                            </button>

                            <br /><br />

                            <button (click)="etoroInf(3)" id="SmartStock" type="button" class="landingBtn btn-primary">
                                <li class="padTopMobileButton">
                                  
                                    <img src="assets/img/svg/ico-list-2.svg" alt="Item 2" loading="lazy">

                                    <h5 style="line-height: 96%">Advanced Analytics & Intelligence</h5>

                                    <p style="color: black">Each month the algorithm updates the Top 20 for the coming
                                        month. Selecting the Top 20
                                        provides diversification within the portfolio.</p>
                              
                                </li>
                            </button>

                            <br /><br />

                            <button (click)="etoroInf(4)" id="SmartStock" type="button" class="landingBtn btn-primary">
                                <li class="padTopMobileButton">
                               
                                    <img src="assets/img/svg/ico-list-3.svg" alt="Item 3" loading="lazy">

                                    <h5 style="line-height: 96%">Diversified Approach</h5>

                                    <p style="color: black">This diversification reduces risk exposure whilst targeting
                                        a net-profit of 15 – 25%.</p>
                              
                                </li>
                            </button>

                            <li style="margin-top: 2rem">
                                <a (click)="etoroInf(1)" id="Etoro"><img src="assets/img/logo-hd.png" loading="lazy"
                                        alt="Click here for more eToro information" class="etoroBtnHowDesk"></a>
                            </li>
                        </ul>


                        <!-- <div *ngIf="!mobile">
                        <a (click)="etoroInf(1)" id="Etoro"><img src="assets/img/svg/section-icon-1.svg"
                                loading="lazy" alt="Click here for more eToro information"
                                class="section__icon etoroBtnHowDesk"></a>
                    </div> -->
                        <!-- <div *ngIf="mobile" class="etoroBtnPosMob">
                        <a (click)="etoroInf(1)" id="Etoro"><img src="assets/img/logo-hd.png"
                                loading="lazy" alt="Click here for more eToro information"
                                class="etoroBtnHowDesk"></a>
                    </div> -->

                    </div><!-- /.section__content -->
                </div><!-- /.shell -->
            </section>
        </div>
    </div>
    <br /><br /><br />
    <div *ngIf="!mobile">
        <section class="section" id="backtesting">
            <div class="shell shell--size-6">
                <div class="box">
                    <div class="grid">
                        <div class="grid__col grid__col--size-1">
                            <div class="box__image">
                                <img src="assets/img/temp/box-img-1.jpg" loading="lazy"
                                    alt="Plot of the Backseat-Trader algorithm's backtesting results through the development phase">

                                <div class="section__callout">
                                    <h5 style="margin-bottom: -11%">Check out how Backseat Trader is <span>performing on
                                            eToro currently</span></h5>

                                    <a [routerLink]="['/join-us']" class="btn btn--size-5" rel="noopener noreferrer"
                                        id="homeJoinUs4" (click)="capturePos()" style="margin-right: 2%">Join us on
                                        eToro</a>

                                    <div class="row"
                                        style="font-size: small; margin-left: 62%; margin-top: 2%; text-align: center;">
                                        Copy Trading does not amount to investment advice. Your investments value may go
                                        up or down. Your capital is at risk.
                                    </div>
                                </div><!-- /.section__callout -->

                            </div><!-- /.box__image -->

                        </div><!-- /.grid__col -->

                        <div class="grid__col grid__col--size-2">
                            <div class="box__content">
                                <h6>Backtesting</h6>

                                <h2 class="white">Feasibility Analysis 27% Annualised Return</h2>

                                <p class="wow fadeInUp" data-wow-delay=".5s">This summary page presents an outline of
                                    the approach Cosmic Algorithm Ltd (CAL) undertook when developing the
                                    Backseat-Trader algorithm.</p>

                                <p class="wow fadeInUp" data-wow-delay=".6s">{{backtestingText}} is a comparison
                                    between the algorithm's historical equity curve versus the value of SPY, QQQ, and
                                    SPY-AGG 70/30 portfolio equity curves. All systems are rebalanced monthly with
                                    US$10,000 initial investment. There is no capital reinvestment assumed.</p>

                                <p class="wow fadeInUp" data-wow-delay=".7s">CAL can supply the back-testing data used
                                    in electronic format, upon request.</p>

                                <p class="wow fadeInUp" data-wow-delay=".8s">A momentum-based semi-automated stock
                                    rotation system. Only long positions are traded. The system tracks NASDAQ index
                                    components on a daily basis and selects the top 20 best performing stocks of the
                                    index. The selection is rebalanced once per month which increases return and reduces
                                    volatility.</p>
                            </div><!-- /.box__content -->
                        </div><!-- /.grid__col -->
                    </div><!-- /.grid -->
                </div><!-- /.box -->
            </div><!-- /.shell -->
        </section><!-- /.section -->
        <br /><br />
    </div>
    <div *ngIf="mobile">
        <section class="section" id="backtesting">
            <div class="shell shell--size-6">
                <div class="box">
                    <div class="grid">
                        <div class="grid__col grid__col--size-1">
                            <div class="box__image" style="background-color: white;     
                            width: 100vw;
                            margin-left: -4%;">
                                <img src="assets/img/temp/box-img-1.jpg" loading="lazy"
                                    alt="Plot of the Backseat-Trader algorithm's backtesting results through the development phase">

                                    <div class="section__callout">
                                        <h5>Check out how Backseat Trader is <span>performing on eToro currently</span></h5>
    
                                        <a [routerLink]="['/join-us']" class="btn btn--size-5" rel="noopener noreferrer"
                                            id="homeJoinUs4" (click)="capturePos()" style="margin-right: 2%">Join us on
                                            eToro</a>
                                    </div><!-- /.section__callout -->
                                
                            </div><!-- /.box__image -->

                        </div><!-- /.grid__col -->

                        <div class="grid__col grid__col--size-2">
                            <div class="box__content">
                                <div
                                    style="font-size: small; text-align: center; color: white; margin-top: -9%; margin-bottom: 12%">
                                    Copy Trading does not amount to investment advice. Your investments value may go up
                                    or down. Your capital is at risk.
                                </div>
                                <h6>Backtesting</h6>

                                <h2 class="white">Feasibility Analysis 27% Annualised Return</h2>

                                <p class="wow fadeInUp" data-wow-delay=".5s">This summary page presents an outline of
                                    the approach Cosmic Algorithm Ltd (CAL) undertook when developing the
                                    Backseat-Trader algorithm.</p>

                                <p class="wow fadeInUp" data-wow-delay=".6s">{{backtestingText}} is a comparison
                                    between the algorithm's historical equity curve versus the value of SPY, QQQ, and
                                    SPY-AGG 70/30 portfolio equity curves. All systems are rebalanced monthly with
                                    US$10,000 initial investment. There is no capital reinvestment assumed.</p>

                                <p class="wow fadeInUp" data-wow-delay=".7s">CAL can supply the back-testing data used
                                    in electronic format, upon request.</p>

                                <p class="wow fadeInUp" data-wow-delay=".8s">A momentum-based semi-automated stock
                                    rotation system. Only long positions are traded. The system tracks NASDAQ index
                                    components on a daily basis and selects the top 20 best performing stocks of the
                                    index. The selection is rebalanced once per month which increases return and reduces
                                    volatility.</p>
                            </div><!-- /.box__content -->
                        </div><!-- /.grid__col -->
                    </div><!-- /.grid -->
                </div><!-- /.box -->
            </div><!-- /.shell -->
        </section><!-- /.section -->
    </div>
    <div *ngIf="!mobile">
        <br /><br /><br /> <br /><br /><br />
    </div>
    <div *ngIf="mobile">
        <br /><br /><br />
    </div>
    <ngb-pagination [collectionSize]="60" class="d-flex justify-content-center" [(page)]="currentPage" size="lg"
        (pageChange)="onPaginationClick($event)" style="font-size: large"></ngb-pagination>
    <div class="pagHeight" id="pagContainer">
        <div id="mainStats">
            <app-main-graph></app-main-graph>
        </div>
        <div id="mainStatsPara" class="mfp-hide">
            <section class="section">
                <div class="shell shell--size-3">
                    <br />
                    <div class="row chart" id="chartSize" style="font-size: large">
                        <h1>Backseat Trader - Trading Performance</h1>
                        Per the previous carousel item, we report-out on a monthly cycle as to the performance of our
                        algorithm referencing the market conditions as they applied to the NASDAQ index.<br /><br />
                        <br /><br />

                        <div style="width:100%; text-align: center;">
                            <a href="https://drive.google.com/file/d/1Y3zGF8fF8Rh3h5xh-oZxprgrb3ytf3H-/view?usp=sharing"
                                class="btn joinUsBtn" rel="noopener noreferrer" id="homeJoinUs1" (click)="capturePos()"
                                target="_blank">READ MORE</a>
                        </div>
                        <br /><br />
                    </div>
                </div>
            </section>
        </div>
        <div id="mainExe" class="mfp-hide">
            <app-main-executions></app-main-executions>
        </div>
        <div id="mainExePara" class="mfp-hide">
            <section class="section">
                <div class="shell shell--size-3">
                    <br />
                    <div class="row chart" id="chartSize" style="font-size: large">
                        <h1>Backseat Trader - Trade Executions</h1>
                        Per the previous carousel item, we report-out on a monthly cycle as to the performance of our
                        algorithm referencing the market conditions as they applied to the NASDAQ index.<br /><br />
                        <br /><br />

                        <div style="width:100%; text-align: center;">
                            <a href="https://drive.google.com/file/d/1YWNM-qIxUz4aZl0MKvCrRgKSxeFSoQbM/view?usp=sharing"
                                class="btn joinUsBtn" rel="noopener noreferrer" id="homeJoinUs1" (click)="capturePos()"
                                target="_blank">READ MORE</a>
                        </div>
                        <br /><br />

                    </div>
                </div>
            </section>
        </div>
        <div id="mainPortfolio" class="mfp-hide">
            <app-main-portfolio></app-main-portfolio>
        </div>
        <div id="mainPortPara" class="mfp-hide">
            <section class="section">
                <div class="shell shell--size-3">
                    <br />
                    <div class="row chart" id="chartSize" style="font-size: large">
                        <h1>Backseat Trader - Portfolio</h1>
                        Per the previous carousel item, we report-out on a monthly cycle as to the performance of our
                        algorithm referencing the market conditions as they applied to the NASDAQ index.<br /><br />
                        <br /><br />

                        <div style="width:100%; text-align: center;">
                            <a href="https://drive.google.com/file/d/1YG0fu85q3XRcYMGYgrQ1YnqbQRUIhROT/view?usp=sharing"
                                class="btn joinUsBtn" rel="noopener noreferrer" id="homeJoinUs1" (click)="capturePos()"
                                target="_blank">READ MORE</a>
                        </div>
                        <br /><br />
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div *ngIf="!mobile">
        <br /><br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> 
    </div>
    <div *ngIf="mobile">
        <br /><br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />
    </div>

    <section class="section-circles" *ngIf="!mobile" id="bubbles">
        <div class="shell shell--size-5">
            <div class="section__inner">
                <div class="section__head">
                    <h4 class="circlesTitle">Method</h4>

                    <h4 class="wow fadeInRight" data-wow-delay=".2s">Cosmic Algorithm summarily lists the
                        analytical methodologies for this algorithm</h4>
                </div><!-- /.section__head -->

                <div class="section__content">
                    <ul>
                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Runs on daily candles
                        </li>

                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Absolute momentum quantification mechanism based on 13612 weighted filter
                        </li>

                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Relative momentum ranking and weight allocation system
                        </li>

                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Support for stock and ETF portfolios
                        </li>

                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Support for leveraged & unleveraged accounts
                        </li>

                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Adjustable rebalance period
                        </li>
                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <a (click)="etoroInf(5)" id="Methodology">
                                <i [class.hovered]="scrolledToElement.reachedBubblesLanding"
                                    class="fa-solid fa-circle-info fa-3x circlesI" placement="top"
                                    ngbTooltip="Read More" tooltipClass="toolTips" scrolledTo
                                    #scrolledToElement="scrolledTo">
                                </i></a>
                        </li>
                    </ul>
                </div><!-- /.section__content -->

                <div class="section__foot">
                    <div>
                        <h6 class="wow fadeInRight white" data-wow-delay=".2s">Get started with </h6>

                        <h2 class="wow fadeInRight white" data-wow-delay=".2s">US $200</h2>

                        <a [routerLink]="['/join-us']" class="btn btn--size-4 joinUsBtn"
                            rel="noopener noreferrer" id="homeJoinUs3" (click)="capturePos()">Join us on eToro</a><br/>
                    </div>
                        <div style="font-size: small;
                        margin-top: 3vh;
                        width: 100%;">
                            <div style="padding-left: 10%;padding-right: 10%;">Copy Trading does not amount to investment advice. Your investments value may go up or down. Your capital is at risk.</div>
                        </div>
                </div><!-- /.section__foot -->
            </div><!-- /.section__inner -->
        </div><!-- /.shell -->
    </section><!-- /.section-circles -->

    <section class="section-circles" *ngIf="mobile" id="bubbles">
        <div class="shell shell--size-5">
            <div class="section__inner">
                <div class="section__head">
                    <h4 class="circlesTitle">Method</h4>

                    <h4 class="wow fadeInRight" data-wow-delay=".2s">Cosmic Algorithm summarily lists the
                        analytical methodologies for this algorithm</h4>
                </div><!-- /.section__head -->

                <div class="section__content">
                    <ul class="circlesMarg">
                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Runs on daily candles
                        </li>

                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Absolute momentum quantification mechanism based on 13612 weighted filter
                        </li>

                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Relative momentum ranking and weight allocation system
                        </li>

                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Support for stock and ETF portfolios
                        </li>

                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Support for leveraged & unleveraged accounts
                        </li>

                        <li class="wow fadeInRight" data-wow-delay=".2s">
                            <img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

                            Adjustable rebalance period
                        </li>
                        <li>
                            <a (click)="etoroInf(5)" class="circlesIMob" id="Methodology">
                                <i [class.hovered]="scrolledToElement.reachedBubblesLanding"
                                    class="fa-solid fa-circle-info fa-3x circlesIMob2" scrolledTo
                                    #scrolledToElement="scrolledTo">
                                </i></a>
                        </li>
                    </ul>
                </div><!-- /.section__content -->

                <div class="section__foot footerSize">
                    <h6 class="wow fadeInRight white" data-wow-delay=".2s">Get started with </h6>

                    <h2 class="wow fadeInRight white" data-wow-delay=".2s">US $200</h2>

                    <a [routerLink]="['/join-us']" class="btn btn--size-4 joinUsBtn"
                        rel="noopener noreferrer" id="homeJoinUs3" (click)="capturePos()">Join us on eToro</a>
                </div><!-- /.section__foot -->
            </div><!-- /.section__inner -->
        </div><!-- /.shell -->
    </section><!-- /.section-circles -->
    <div *ngIf="mobile" style="text-align: center; font-size: small; margin-left: 10%; margin-right: 10%;"><br/>Copy Trading does not amount to investment advice. Your investments value may go up or down. Your capital is at risk.</div>
    <div>
        <br /><br /> <br /> <br />
    </div>
    <div class="row" style="    
    display: flex;
    /* flex-wrap: wrap; */
    justify-content: center;" *ngIf="!mobile">
        <div class="col-auto" style="background-color: #2C3B51;">

            <button data-bs-toggle="modal" data-bs-target="#myModal"
                style="background-image: url('../../assets/img/temp/hero-img.png'); height: 23vh; width: 25vw; background-size: contain;
            background-repeat: no-repeat; background-color: #2C3B51; border:#2C3B51; text-align: right; padding-right: 7.6rem">

                <!-- <img src="../../assets/img/temp/hero-img.png" style="max-width: 100%" /> -->
                <i class="fa-regular fa-circle-play" style="color: white; font-size: xxx-large"></i>
            </button>

        </div>
        <div class="col-auto" style="background-color: #2C3B51; padding-right: 10px;     
        display: flex;
        flex-wrap: wrap;
        align-content: center;">
            <div class="row">
                <div class="col">
                    <ul style="color: white; font-size: medium;  list-style-type: none;">
                        <li class="wow fadeInUp" data-wow-delay=".5s">
                            <img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

                            <img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
                                class="hidden visible-xs-block">

                            No trading experience required
                        </li>

                        <li class="wow fadeInUp" data-wow-delay="1.5s">
                            <img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy" />

                            <img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
                                class="hidden visible-xs-block">

                            Backseat-Trader trades for you
                        </li>

                        <li class="wow fadeInUp" data-wow-delay="2.5s">
                            <img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

                            <img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
                                class="hidden visible-xs-block">

                            Join Backseat-Trader with just US $200
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="
    background-image: url('../../assets/img/temp/hero-img.png'); background-size: contain;
    background-repeat: no-repeat; background-color: #2C3B51; border:#2C3B51;    
    display: flex;
    /* flex-wrap: wrap; */
    justify-content: center;
    align-items: center;" *ngIf="mobile">
        <div class="col-5" style="text-align: center;">

            <button data-bs-toggle="modal" data-bs-target="#myModal" style="border-style: none;
    background-color: rgb(255 0 0 / 0%);">
                <i class="fa-regular fa-circle-play" style="color: #5ECE42; font-size: xxx-large"></i>
            </button>

        </div>
        <div class="col-5" style="   
        display: flex;
        flex-wrap: wrap;
        align-content: center;">
            <div class="row">
                <div class="col">
                    <ul style="color: white; font-size: medium;  list-style-type: none;">
                        
                        <li class="wow fadeInUp" data-wow-delay=".5s" style="display: flex; gap: 10px; color: #5ECE42; font-weight: bold">
                            <img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

                            <img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
                                class="hidden visible-xs-block">

                            &nbsp;No trading experience required
                        </li>
                        <br/>

                        <li class="wow fadeInUp" data-wow-delay="1.5s" style="display: flex; gap: 10px; color: #5ECE42; font-weight: bold">
                            <img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy" />

                            <img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
                                class="hidden visible-xs-block">

                            Backseat-Trader trades for you
                        </li>
                        <br/>
                        <li class="wow fadeInUp" data-wow-delay="2.5s" style="display: flex; gap: 10px; color: #5ECE42; font-weight: bold">
                            <img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

                            <img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
                                class="hidden visible-xs-block">

                            Join Backseat-Trader with just US $200
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- <br /> -->
    <!-- <div class="row">
        <div class="col">
            <div style="width:100%; text-align: center;">
                <a [routerLink]="['/join-us']" class="btn joinUsBtn" rel="noopener noreferrer" id="homeJoinUs1"
                    (click)="capturePos()">Join us on eToro</a><br /><br />
                <div style="font-size:small">
                    Copy Trading does not amount to investment advice. Your investments value may go up or down.
                    Your capital is at risk.
                </div>
            </div>
        </div>
    </div> -->

    <div *ngIf="!mobile">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
    </div>
    <div *ngIf="mobile">
        <br />
    </div>
    <!-- <div class="row">
        <div class="col" style="margin-left: 5rem; margin-right: 5rem">
            <h1 style="font-weight: 600;">Creating Your eToro Account</h1>
        </div>
    </div> -->
    <div class="row" style="left: 5vw;
    position: relative;" *ngIf="!mobile">
        <div class="col">
            <div class="row" style="margin-top: 3rem">
                <div class="col-auto" style="display: flex;
                align-content: baseline;
                flex-wrap: wrap; margin-right: 2.5rem">
                    <a [routerLink]="['/register']"><i [class.hovered]="scrolledToElement.reachedColumn" scrolledTo
                            #scrolledToElement="scrolledTo" class="fa-solid fa-circle-info"
                            style="font-size: x-large"></i></a>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <h1 style="font-weight: 600; padding-right:50%">Creating Your Account</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="font-size: large; color: #757575; padding-right: 36%">
                            For more information on how to create your Backseat Trader account, click the information
                            icon above.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="row" style="margin-top: 3rem">
                <div class="col-auto" style="display: flex;
                align-content: baseline;
                flex-wrap: wrap; margin-right: 2.5rem">
                    <a [routerLink]="['/academy']"><i [class.hovered]="scrolledToElement.reachedColumn" scrolledTo
                            #scrolledToElement="scrolledTo" class="fa-solid fa-circle-info"
                            style="font-size: x-large"></i></a>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <h1 style="font-weight: 600;">Academy</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="font-size: large; color: #757575; padding-right: 36%">
                            If you would like to see our video Academy, which provides high quality content on some
                            eToro and trading concepts, click the information icon above.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="row" style="margin-top: 3rem">
                <div class="col-auto" style="display: flex;
                align-content: baseline;
                flex-wrap: wrap; margin-right: 2.5rem">
                    <a [routerLink]="['/etoro']"><i [class.hovered]="scrolledToElement.reachedColumn" scrolledTo
                            #scrolledToElement="scrolledTo" class="fa-solid fa-circle-info"
                            style="font-size: x-large"></i></a>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <h1 style="font-weight: 600;">Feed</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="font-size: large; color: #757575; padding-right: 36%">
                            If you would like to review our regularly updated feed, where we publish what's new with
                            Backseat Trader, click the information icon above.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="max-width: 100%; margin-left: 2%" *ngIf="mobile">
        <div class="row">
            <div class="row" style="margin-top: 3rem">
                <div class="col-auto" style="display: flex;
                align-content: baseline;
                flex-wrap: wrap; margin-right: 2.5rem">
                    <a [routerLink]="['/register']"><i [class.hovered]="scrolledToElement.reachedColumn" scrolledTo
                            #scrolledToElement="scrolledTo" class="fa-solid fa-circle-info"
                            style="font-size: x-large"></i></a>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <h1 style="font-weight: 600;">Creating Your Account</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="font-size: large; color: #757575;">
                            For more information on how to create your Backseat Trader account, click the information
                            icon above.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="row" style="margin-top: 3rem">
                <div class="col-auto" style="display: flex;
                align-content: baseline;
                flex-wrap: wrap; margin-right: 2.5rem">
                    <a [routerLink]="['/academy']"><i [class.hovered]="scrolledToElement.reachedColumn" scrolledTo
                            #scrolledToElement="scrolledTo" class="fa-solid fa-circle-info"
                            style="font-size: x-large"></i></a>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <h1 style="font-weight: 600;">Academy</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="font-size: large; color: #757575;">
                            If you would like to see our video Academy, which provides high quality content on some
                            eToro and trading concepts, click the information icon above.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="row" style="margin-top: 3rem">
                <div class="col-auto" style="display: flex;
                align-content: baseline;
                flex-wrap: wrap; margin-right: 2.5rem">
                    <a [routerLink]="['/etoro']"><i [class.hovered]="scrolledToElement.reachedColumn" scrolledTo
                            #scrolledToElement="scrolledTo" class="fa-solid fa-circle-info"
                            style="font-size: x-large"></i></a>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <h1 style="font-weight: 600;">Feed</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" style="font-size: large; color: #757575;">
                            If you would like to review our regularly updated feed, where we publish what's new with
                            Backseat Trader, click the information icon above.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br /><br /><br />
    <div class="row">
        <div class="col">
            <div style="width:100%; text-align: center;">
                <a [routerLink]="['/join-us']" class="btn joinUsBtn" rel="noopener noreferrer" id="homeJoinUs1"
                    (click)="capturePos()">Join us on eToro</a><br /><br />
                <div style="font-size:small" *ngIf="!mobile">
                    Copy Trading does not amount to investment advice. Your investments value may go up or down.
                    Your capital is at risk.
                </div>
                <div style="font-size:small; margin-left: 10%; margin-right: 10%" *ngIf="mobile">
                    Copy Trading does not amount to investment advice. Your investments value may go up or down.
                    Your capital is at risk.
                </div>
            </div>
        </div>
    </div>
    <br /><br />
</div>

<div class="modal" id="myModal">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">


            <div class="modal-body">
                <video height="95%" width="100%" controls #homeVideo>
                    <source src="https://theapi.backseat-trader.com/Introducing-IBKR.mp4" type="video/mp4">
                </video>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer" style="    margin: auto;
            margin-bottom: 1%;
            margin-top: -1%;">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                    (click)="close(homeVideo)">Close</button>
            </div>

        </div>
    </div>
</div>